import './styles/global.css';
import '@arpm/ui/fonts.css';
import '@arpm/ui/tokens.css';
import '@arpm/ui/styles';

import { VueQueryPlugin } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from './App.vue';
import { initTheme } from './composables/useTheme.js';
import { i18n } from './i18n/index.js';
import { router } from './router/index.js';
import { useAuthStore } from './stores/auth.js';

async function bootstrap() {
  // До монтирования — иначе сохранённая тёмная тема мигнёт светлой.
  initTheme();

  const app = createApp(App);
  app.use(createPinia());
  app.use(i18n);
  app.use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries: {
          retry: 1,
          staleTime: 30_000,
          refetchOnWindowFocus: false,
        },
      },
    },
  });

  const auth = useAuthStore();
  await auth.initialize();

  app.use(router);
  app.mount('#app');
  startServiceWorker();
}

/**
 * Service worker — только для пуш-уведомлений и числа на иконке (public/sw.js,
 * без кеширования). Клик по уведомлению при открытой вкладке приходит сюда
 * сообщением — переходим через роутер, без перезагрузки и повторного входа.
 */
function startServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.addEventListener('message', (e: MessageEvent<{ type?: string; path?: string }>) => {
    if (e.data.type === 'intranet:navigate' && typeof e.data.path === 'string' && e.data.path.startsWith('/')) {
      void router.push(e.data.path);
    }
  });
  navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' }).catch((err: unknown) => {
    // eslint-disable-next-line no-console
    console.warn('Service worker не зарегистрирован', err);
  });
}

bootstrap().catch((err) => {
  // eslint-disable-next-line no-console
  console.error('Не удалось загрузить intranet-web', err);
});
